import { useState } from "react";
import { uploadsUrl } from "../utils/api";
import "./AmenitiesSection.css";

// 🔹 Read More
function ReadMore({ text, extra, limit = 120 }) {
  const [expanded, setExpanded] = useState(false);
  const full = [text, extra].filter(Boolean).join(" ");

  if (!full) return null;
  if (full.length <= limit) return <p>{full}</p>;

  return (
    <p>
      {expanded ? full : full.slice(0, limit) + "…"}
      <button
        className="read-more-btn"
        onClick={() => setExpanded((e) => !e)}
      >
        {expanded ? " Read Less" : " Read More..."}
      </button>
    </p>
  );
}

// 🔹 Main Component
export default function AmenitiesSection({ projectId, amenities = {} }) {
  const { list = [] } = amenities;

  if (!list.length) return null;

  const doubled = [...list, ...list];

  return (
    <section className="amenities-section section">
      <h2 className="section-heading">World-Class Amenities</h2>

      <div className="amenities-track-wrapper">
        <div className="amenities-track">
          {doubled.map((item, i) => {
            const index = (i % list.length) + 1;

            return (
              <article key={i} className="amenity-card">
                
                {/* ✅ CORRECT IMAGE */}
                <div className="amenity-card__img">
                  <img
                    src={uploadsUrl(projectId, `amenities${index}.webp`)}
                    alt={item.title}
                    loading="lazy"
                    onError={(e) => (e.target.src = "/fallback.webp")}
                  />
                </div>

                <div className="amenity-card__body">
                  <h3>{item.title}</h3>

                  <ReadMore
                    text={item.description}
                    extra={item.moreDetails}
                    limit={120}
                  />
                </div>

              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}